var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var TableVisualParams_1;
import { JSON, JsonDiscriminatorValue, JsonSchemaV2 } from '@symon-ai/wisepipe-serialize';
import './tableColumn'; // force import for JsonSchemaV2
import { NumericFormatTypes } from './tableColumn';
import { VisualParams } from './visualParams';
import { VisualType } from '@symon-ai/wisepipe-base-computation';
import { tableVisualParamsSchemaValidation } from '../validations.generated';
export const tableVisualParamsSchema = {
    $id: 'urn:wisepipe-common-computation:TableVisualParams',
    type: 'object',
    properties: {
        columns: {
            type: 'array',
            items: { $ref: 'urn:wisepipe-common-computation:TableColumn' },
            minItems: 1,
            uniqueItemProperties: ['name']
        }
    },
    required: ['columns']
};
let TableVisualParams = TableVisualParams_1 = class TableVisualParams extends VisualParams {
    constructor(args) {
        super({
            ...args,
            type: VisualType.Table
        });
        this.columns = args.columns;
        JSON.validate(this, TableVisualParams_1);
    }
    getFields() {
        return this.columns.map((column) => {
            const field = { source: column.name, alias: column.name };
            if (column.numericFormat?.decimals !== undefined) {
                const decimals = column.numericFormat.decimals;
                // eslint-disable-next-line dot-notation
                field['decimals'] = column.numericFormat.type === NumericFormatTypes.Percent ? decimals + 2 : decimals;
            }
            return field;
        });
    }
    setFinalQuery(query, type, tableName) {
        return query;
    }
};
TableVisualParams = TableVisualParams_1 = __decorate([
    JsonSchemaV2(tableVisualParamsSchema, tableVisualParamsSchemaValidation),
    JsonDiscriminatorValue(VisualType.Table)
], TableVisualParams);
export { TableVisualParams };
//# sourceMappingURL=tableVisualParams.js.map